<template>
  <div class="search-bar">
    <input type="text" ref="search" v-on:blur="focusLost()" v-on:focus="searchResults.length > 0 ? showSearchResults() : hideSearchResults()" :placeholder="$t('label.search')" class="input text" :v-model="searchQuery" v-on:keyup="$data.searchQuery = $event.target.value">
    <ul class="search-results" :class="searchResultsShown ? 'shown' : ''">
      <li v-for="article in searchResults" :key="article.id" class="row" v-on:click="showArticle(article.articleTranslations[0].slug)">
        <div class="inner col-lg-8 col-md-12">
          <div class="type">{{ article.articleType.name }}</div>
          <div class="date">{{ formatDate(article.publishDate) }}</div>
          <div class="title">{{ article.articleTranslations[0].title }}</div>
        </div>
        <div class="image col-4 hidden-sm-down" :style="'background: url(' + (article.image != null ? article.image : '/static/placeholders/placeholder-logo.jpg') + ') center center; background-size: cover;'"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import ArticlesService from '@/services/ArticlesService'

export default {
  name: 'Search',
  data() {
    return {
      searchQuery: '',
      searchResults: [],
      searchResultsShown: false
    }
  },
  computed: {
    searchResultsExist: function() {
      return this.searchResults != null && this.searchResults.length > 0
    }
  },
  methods: {
    showArticle: function(slug) {
      this.searchQuery = ''
      this.searchResults = []
      this.$refs.search.value = ''
      this.$router.push({ name: 'article', params: { slug: slug } })
    },
    focusLost: function() {
      setTimeout(() => {
        this.hideSearchResults()
      }, 250)
    },
    hideSearchResults: function() {
      this.searchResultsShown = false
    },
    showSearchResults: function() {
      this.searchResultsShown = true
    }
  },
  watch: {
    searchQuery: function() {
      if (this.searchQuery.length === 0) {
        this.searchResults = []
        return
      }
      ArticlesService.search(this.searchQuery)
        .then(response => {
          console.log(response)
          this.searchResults = response.body
          this.showSearchResults()
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/_vars.scss";

.transparent {
  .search-bar input {
    background: rgba(255, 255, 255, 0.3);
    color: black;

    &:focus {
      background: rgba(255, 255, 255, 0.8);
    }
  }
}

.search-bar {
  transform: translateY(20%);
  height: 80%;

  input {
    transition: all 0.2s;
    color: white;
    outline: none;
    border-radius: 0.25rem;
    border: none;
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
    background: darken($primary-color, 10%);

    &:focus {
      background: darken($primary-color, 5%);
    }
  }
}

.search-results {
  display: none;
  padding: 0;
  background: white;
  position: absolute;
  top: 2rem;
  right: 0;
  border-radius: 0.25rem;
  box-shadow: $drop-shadow-card;
  width: 300%;
  max-height: 300px;
  overflow: scroll;
  list-style: none;

  &.shown {
    display: block;
  }

  li {
    margin: 0;
    box-sizing: border-box;
    cursor: pointer;
    border-bottom: 1px solid $feed-line-color;

    .inner {
      padding: 1rem;
    }
    .title {
      font-size: 1rem;
    }
    .type {
      color: $primary-color;
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: $bold;
      letter-spacing: $letter-spacing-date;
    }

    .date {
      font-size: 0.75rem;
      color: $txt-color-secondary;
    }

    &:hover {
      background: darken(white, 5%);
    }
  }

  @media (max-width: $device-md) {
    width: 100%;

    li {
      .image {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// SearchComponent.vue?00d78005